<template>
  <b-list-group-item>
    <div class="font-weight-bold text-primary">
      Açıklama
    </div>
    <template v-if="dataItem.notes">
      <div>{{ dataItem.notes }}</div>
    </template>
    <template v-else>
      <div class="text-muted">
        Belirtilemdi
      </div>
    </template>
  </b-list-group-item>
</template>
<script>
import { BListGroupItem } from 'bootstrap-vue'

export default {
  name: 'NotesText',
  components: {
    BListGroupItem,
  },
  computed: {
    dataItem() {
      return this.$store.getters['accountActivities/dataItem']
    },
  },
}
</script>
